import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';
import { condensedStyles } from 'core/components/theme/condensed-layout';
import { clearNavRail } from 'core/components/nav-rail/nav-rail-width';

const useStyles = makeStyles((theme) => ({
  title: {
    height: 34,
    fontWeight: 300,
    paddingLeft: theme.spacing(2),
    color: theme.colorPalette.green_100
  },
  footerContainer: {
    height: 98,
    display: 'flex',
    background: theme.colors.footer_background_primary,
    boxShadow: '0px -1px 3px 0px rgba(0,0,0,0.2)',
    ...reskinStyles(theme, { boxShadow: theme.surfaceShadows.footer })
  },
  footerAlertOrange: {
    background: theme.colorPalette.orange_50
  },
  footerAlertRed: {
    background: theme.colorPalette.red_100
  },
  floatingContainer: {
    position: 'fixed',
    left: 0,
    width: '100%',
    bottom: 0,
    zIndex: 1000,
    ...condensedStyles(theme, clearNavRail(theme))
  },
  footerContent: {
    width: '100%',
    maxWidth: 1280,
    height: 98,
    margin: theme.spacing(0, 'auto'),
    // Beside the condensed rail the footer is narrower than maxWidth, so the auto margins are 0.
    ...condensedStyles(theme, { padding: theme.spacing(0, 6) })
  },
  subtitle: {
    marginLeft: 10,
    color: theme.colorPalette.green_100
  },
  agentSold: {
    textAlign: 'right',
    color: theme.colorPalette.white
  },
  subtitleLink: {
    color: theme.colorPalette.white,
    borderBottom: `1px solid ${theme.colorPalette.white}`,
    marginLeft: '3px',
    cursor: 'pointer'
  },
  cancelledTextContainer: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column'
  },
  cancelCallOut: {
    display: 'flex',
    flexDirection: 'row'
  }
}));

export default useStyles;
